import { Injectable } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { BehaviorSubject, Observable, combineLatest, filter } from 'rxjs';
import { map } from 'rxjs/operators';
import { PermissionsService } from '../../pages/options/admin/profiling/services/permissions.service';
import { AuthService } from '../auth/auth.service';
import { outlineService } from '../auth/outline.service';
import { NavigationDropdown, NavigationItem, NavigationLink } from './navigation-item.interface';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> = new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor(
    private readonly layoutService: VexLayoutService,
    private authService: AuthService,
    private outlineService: outlineService,
    private permissionsService: PermissionsService  // Inyectar el PermissionsService

  ) {
    /*     this.loadNavigation();
     */    // Suscribirse a los cambios de permisos

    combineLatest([
      this.authService.currentUser$.pipe(filter(user => !!user)), // Espera a que haya un usuario
      this.permissionsService.permissions$
    ]).subscribe(([user, _]) => {
      const perfilId = user!.idPerfil;

      if (perfilId !== undefined && perfilId !== null) {
        this.loadNavigation(); // Ya puedes cargar el menú
      } else {
        console.error('No se pudo obtener el perfilId.', user);
      }
    });


  }

  loadNavigation(): void {
    const perfilId = this.authService.getCurrentUser()?.idPerfil;



    if (typeof perfilId === 'number' && !isNaN(perfilId)) {
      // Cargar los permisos del usuario antes de generar el menú
      this.outlineService.cargarPermisos(perfilId).pipe(
        map(() => {
          // Definir el menú completo
          const items: NavigationItem[] = [
            {
              type: 'subheading',
              label: 'Inicio',
              children: [
                {
                  type: 'link',
                  label: 'Dashboard',
                  route: '/home/dash',
                  icon: 'mat:dashboard',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 1,
                  id_vista: 1
                }
              ]
            },
            {
              type: 'subheading',
              label: 'Personas',
              children: [
                {
                  type: 'link',
                  label: 'Contactos',
                  route: '/personas/contactos',
                  icon: 'mat:dashboard',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 2,
                  id_vista: 2
                },
                //* modulos que no se desarrollarán
                /* {
                  type: 'link',
                  label: 'Voluntarios',
                  route: '/personas/voluntarios',
                  icon: 'mat:dashboard',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 2,
                  id_vista: 31
                },
                {
                  type: 'link',
                  label: 'Equipo primario',
                  route: '/personas/equipo-primario',
                  icon: 'mat:dashboard',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 2,
                  id_vista: 32
                } */
              ]
            },
            {
              type: 'subheading',
              label: 'Procesos',
              children: [
                /* {
                  type: 'link',
                  label: 'Gestión',
                  route: '/procesos/gestion',
                  icon: 'mat:manage_accounts',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 3,
                  id_vista: 33
                }, */
                {
                  type: 'link',
                  label: 'Contactabilidad',
                  route: '/procesos/contactabilidad',
                  icon: 'mat:connect_without_contact',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 3,
                  id_vista: 33
                },
                //* modulos que no se desarrollarán
                // NoteAlt,ListAlt,InsertComment
                // {
                //   type: 'link',
                //   label: 'Encuestas',
                //   route: '/procesos/encuestas',
                //   icon: 'mat:quiz',
                //   routerLinkActiveOptions: { exact: true },
                //   id_modulo: 3,
                //   id_vista: 34
                // },
                {
                  type: 'link',
                  label: 'Marketing',
                  route: '/procesos/marketing',
                  icon: 'mat:campaign',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 3,
                  id_vista: 35
                },
                {
                  type: 'link',
                  label: 'Noticias',
                  route: '/procesos/noticias',
                  icon: 'mat:newspaper',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 3,
                  id_vista: 36
                },
                {
                  type: 'link',
                  label: 'Propuestas',
                  route: '/procesos/propuestas',
                  icon: 'mat:assignment',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 3,
                  id_vista: 37
                },
                {
                  type: 'link',
                  label: 'Descartados',
                  route: '/procesos/descartados',
                  icon: 'mat:person_off',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 3,
                  id_vista: 47
                },
                {
                  type: 'link',
                  label: 'Tareas',
                  route: '/procesos/tareas',
                  icon: 'mat:check_circle',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 3,
                  id_vista: 48
                },
              ]
            },
            {
              type: 'subheading',
              label: 'Asistentes',
              children: [
                {
                  type: 'link',
                  label: 'ClaudIA',
                  route: '/ia/assistants',
                  icon: 'mat:smart_toy',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 10,
                  id_vista: 46
                },
              ]
            },
            //        {
            //          type: 'subheading',
            //          label: 'Reportes',
            //          children: [
            //            {
            //              type: 'link',
            //              label: 'Informes',
            //              route: '/reports/information/',
            //              icon: 'mat:insert_chart',
            //              routerLinkActiveOptions: { exact: true },
            //              id_modulo: 4,
            //              id_vista: 14
            //            },
            //            {
            //              type: 'link',
            //              label: 'Monitoreo sistema',
            //              route: '/reports/monitoring/',
            //              icon: 'mat:monitor',
            //              routerLinkActiveOptions: { exact: true },
            //              id_modulo: 4,
            //              id_vista: 20
            //            },
            //            {
            //              type: 'link',
            //              label: 'Monitoreo CatIA',
            //              route: '/reports/monitoring-catia/',
            //              icon: 'mat:analytics',
            //              routerLinkActiveOptions: { exact: true },
            //              id_modulo: 4,
            //              id_vista: 25
            //            },
            //          ]
            //        },
            {
              type: 'subheading',
              label: 'Opciones',
              children: [
                //* modulos que no se desarrollarán
                /* {
                  type: 'link',
                  label: 'Mesa de Ayuda',
                  route: '/opciones/mesa-ayuda/',
                  icon: 'mat:help_center',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 6,
                  id_vista: 15
                },
                {
                  type: 'link',
                  label: 'Soporte',
                  route: '/opciones/soporte/',
                  icon: 'mat:build',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 6,
                  id_vista: 16
                }, */
                /* {
                  type: 'link',
                  label: 'Comunicación',
                  route: '/opciones/comunicacion-wp/',
                  icon: 'mat:inbox',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 6,
                  id_vista: 17
                }, */
                {
                  type: 'link',
                  label: 'Administración',
                  route: '/opciones/administracion/',
                  icon: 'mat:admin_panel_settings',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 6,
                  id_vista: 18
                },
                {
                  type: 'link',
                  label: 'Estadísticas',
                  route: '/opciones/estadisticas/',
                  icon: 'mat:bar_chart',
                  routerLinkActiveOptions: { exact: true },
                  id_modulo: 6,
                  id_vista: 39
                }
              ]
            },
          ];

          // Filtrar los elementos del menú según los permisos del usuario
          const filteredItems = this.filtrarItemsConPermiso(items);

          // Emitir los elementos filtrados
          this._items.next(filteredItems);
        })
      ).subscribe();
    } else {
      console.error('No se pudo cargar el menú: perfilId inválido', perfilId);
    }
  }


  private filtrarItemsConPermiso(items: NavigationItem[]): NavigationItem[] {
    return items
      .map(item => {
        if ('children' in item && item.children) {
          const filteredChildren = this.filtrarChildren(item.children);
          return { ...item, children: filteredChildren };
        }
        return item;
      })
      .filter(item => !('children' in item) || (item.children && item.children.length > 0));
  }

  private filtrarChildren(children: Array<NavigationLink | NavigationDropdown>): Array<NavigationLink | NavigationDropdown> {
    return children.filter(child => {
      if ('id_modulo' in child && 'id_vista' in child && child.id_modulo !== undefined && child.id_vista !== undefined) {
        // Solo llamar a tienePermiso si id_modulo e id_vista están definidos
        return this.outlineService.tienePermiso(child.id_modulo, child.id_vista, 'Ocultar');
      }
      return true; // Si no tiene permisos definidos (id_modulo o id_vista), no se filtra
    });
  }

}